const ufeApi = require('services/api/ufeApi');
const URL = '/api/secure/resetPassword';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Reset+Password+API

function resetPasswordByLogin(email, source) {
    return ufeApi.makeRequest(URL, {
        method: 'POST',
        body: JSON.stringify({
            type: 'email',
            email,
            source: source || undefined
        })
    }).then(data => {
        return data.errorCode ? Promise.reject(data) : data;
    }).catch(err => Promise.reject(err));
}

function resetPassword(email, password, confirmPassword, securityToken) {
    return ufeApi.makeRequest(URL, {
        method: 'POST',
        body: JSON.stringify({
            type: 'reset',
            email,
            password,
            confirmPassword,
            securityToken
        })
    }).then(data => {
        return data.errorCode ? Promise.reject(data) : data;
    }).catch(err => Promise.reject(err));
}

module.exports = {
    resetPasswordByLogin,
    resetPassword
};
